import type { ToastType } from './ToastType'

export type ToastId = string

const toaster = {
  current: (
    _title?: string,
    _content?: string,
    _type?: ToastType,
    _durationMs?: number
  ): ToastId | false => false,
  dismiss: (_id: ToastId): void => {}
}

export const getToaster = (): typeof toaster => toaster
